// **********************************************************
// Timeline slider
// **********************************************************
const updateVisibleSlides = (swiper) => {
  swiper.slides.forEach((slide, i) =>
    slide.classList.toggle(
      'swiper-slide-visible',
      i >= swiper.activeIndex && i < swiper.activeIndex + swiper.params.slidesPerView,
    ),
  );
};

const timelineSwiperElements = document.querySelectorAll('[data-slider="timeline-slider"]');
const timelineSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 600,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
  on: {
    init: updateVisibleSlides,
    slideChange: updateVisibleSlides,
  },
};

timelineSwiperElements.forEach((el) => {
  const mainSliderParent = el.closest('.timeline-slider');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  timelineSliderOptions.navigation.nextEl = arrowRight;
  timelineSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, timelineSliderOptions);
});
